/**
 * English - Footer translations
 */
export const footer = {
  company: 'Company',
  about: 'About Us',
  contact: 'Contact',
  blog: 'Blog',
  inviteFriend: 'Invite a Friend',
  
  legal: 'Legal',
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  security: 'Security',
  compliance: 'Compliance',
  
  support: 'Support',
  helpCenter: 'Help Center',
  faq: 'FAQ',
  contactSupport: 'Contact Support',
  
  connect: 'Connect',

  dueDiligence: 'Due Diligence',
  appraisers: 'Appraisers',
  
  copyright: '© {year} HipoTech. All rights reserved.',
  tagline: 'Multi-bank mortgage and refinancing platform for the Dominican Republic (DR).', // ← was: 'Secure mortgage applications for the Dominican Republic market.'
  
  badges: {
    soc2: 'SOC 2 READY',
    gdpr: 'GDPR ALIGNED',
    zeroBreaches: 'ZERO DATA BREACHES',
  },


  // ── Missing keys added by translation scan ──
  disclaimer: 'This calculator provides estimates only. Actual terms are determined by the bank.',
} as const;
